import { CurrencyCode, isCurrencyCode } from 'utils/currency/getCurrencyCodes'

interface Output {
  code: CurrencyCode
  modifier?: string
}

export function getISOCode(currency: CurrencyCode): Output {
  // To support scenarios where it's [ISO CODE]-[modifier], e.g.
  // ARS-MEP
  if (currency.length > 3) {
    const [code, modifier] = currency.split('-')
    if (isCurrencyCode(code)) {
      return { code, modifier }
    }
    // Let upstream handle it as they've sent us a bogus currency code
  }

  return { code: currency }
}
